import RequestMaster from '../RequestMaster'

export default class RequestPagoInscripcion extends RequestMaster {

    constructor() {
        super()
        this.URL_BASE = this.URL_BASE + '/pago-inscripcion'
    }


    /**
     * Store Multiple
     * 
     * @param {FormData} params
     * @param {Function} callback
     * @param {Function} callbackError
     * @param {Function} callbackFinally
     */
    createMultiple(params, callback = () => { }, callbackError = () => { }, callbackFinally = () => { }) {
        const path = "multiple"
        this.post(path, params, callback, callbackError, callbackFinally)
    }

    updateMultiple(params, callback = () => { }, callbackError = () => { }, callbackFinally = () => { }) {
        const path = "multiple"
        this.put(path, params, callback, callbackError, callbackFinally)
    }
    
}
